import React, { useEffect, useState } from "react";
import { getServiceById } from "../../app/api";
import { useParams } from "react-router-dom";
import ServiceSlider from "./service-slider";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import FloatingShapes from "../common/FloatingShapes";

const HTMLTextView = ({ htmlContent }: any) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export enum NewsType {

  image = "Зураг",
  video = "Бичлэг",
  reminder = "Санамж",
  notice = "Зарлал",

}


export interface INews {
  title: string;
  subtitle: string;
  content: string;
  thumb: string;
  image: [string];
  type: NewsType;
  videoUrl: string;
  createAdmin: string;
  updateAdmin: string;
  status: boolean;
}

export default function ServiceDetail() {

  const [news, setNews] = useState<INews>({} as INews);
  const [images, setImages] = useState<any>([]);

  const params = useParams();

  useEffect(() => {
    try {
      getServiceById(params.id).then((res) => {
        setNews(res.data);
        if (res.data.image && res.data.image.length > 0) {
          setImages(res.data.image.map((image: any) => {
            return {
              original: image,
              thumbnail: image,
            };
          }));
        }
      });
    } catch(err) {
    }
    window.document.body.scrollTop = 0;
    window.document.documentElement.scrollTop = 0;
  }, [params.id]);

  return (
    <>
      {/* Dark hero */}
      <div className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-primary-600/20 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/15 blur-[100px]" />
        </div>
        <FloatingShapes variant="sparse" />
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`,
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative pt-40 pb-12 sm:pt-48 sm:pb-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white tracking-tight">
              {news.title}
            </h1>
          </div>
        </div>
      </div>

      {/* Main Image Hero */}
      {news.thumb && !news.videoUrl && (
        <div className="relative bg-neutral-100">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 -mt-8 relative z-10">
            <div className="relative group">
              <div className="absolute -inset-3 bg-gradient-to-r from-primary-500/30 via-warm-500/20 to-primary-500/30 rounded-3xl blur-2xl opacity-60 group-hover:opacity-80 transition-opacity duration-500" />
              <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-white/20">
                <div className="aspect-[16/9] w-full overflow-hidden bg-neutral-200">
                  <img
                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700 ease-out"
                    src={news.thumb}
                    alt={news.title}
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Video */}
      {news.videoUrl && (
        <div className="relative bg-neutral-100">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 -mt-8 relative z-10">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl ring-1 ring-white/20">
              <div className="relative w-full aspect-video bg-black">
                <iframe
                  src={`https://www.youtube.com/embed/${news.videoUrl.split("v=")[1].split("&")[0]}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Video"
                  className="absolute inset-0 w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          {/* Text content */}
          <div className="prose prose-lg max-w-none text-neutral-600 leading-relaxed">
            <HTMLTextView htmlContent={news.content} />
          </div>

          {/* Image gallery */}
          {news.image && news.image.length > 0 && (
            <div className="mt-16">
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-neutral-200 to-transparent" />
                <h2 className="text-2xl sm:text-3xl font-extrabold">
                  <span className="gradient-text">Зургийн цомог</span>
                </h2>
                <div className="h-px flex-1 bg-gradient-to-r from-transparent via-neutral-200 to-transparent" />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg service-gallery">
                <ImageGallery
                  items={images}
                  showPlayButton={false}
                  showBullets={images.length > 1}
                  lazyLoad={true}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Related services */}
      <div className="bg-neutral-50 py-16 sm:py-20">
        <ServiceSlider />
      </div>
    </>
  );
}
